import React from 'react';
import AnswerField from './AnswerField'
import {device} from '../MainContents/Style/StyleDevice';
import { IoIosArrowRoundDown} from "react-icons/io";
import styled from 'styled-components';

// クッリクするたびにレンダリングは動作してしまうのでコメントアウト
// import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 


const MarginTop = styled.div`;
    margin-top:140px;
`;

const MarginWid =styled.div`
    margin:auto;
    width: 80%;
`;

const ButtonScope =styled.button`
    margin-left: 10px;
    margin-top: 10px;
    padding: 10px;
    border: 0;
    border-bottom: 1px solid black;
    background-color: white;
    text-align: left;
`;
const QuestionTitle = styled.h2`
    background-color: green;
    color: #fff;
    font-weight: bold;
    letter-spacing: 20px;
    padding: 50px 0px 50px;
    margin: 0 auto;
    width: 90%;
    margin-top: 120px;
    border-radius: 10px;
    @media ${device.laptop}{
        letter-spacing: 0px;
    }
`;


class Greeting extends React.Component {
    constructor (props) {
        super(props)
        this.state = {showFlag : true}
        this.state = {showFlag2 : true}
        this.state = {showFlag3 : true}
        this.state = {showFlag4 : true}
        this.state = {showFlag5 : true}
        this.state = {showFlag6 : true}
        this.state = {showFlag7 : true}
        this.state = {showFlag8 : true}
        this.state = {showFlag9 : false}
    }
    
    render () {
        // const showFlag = this.state.showFlag;
        // const showFlag2 = this.state.showFlag2;
        // const showFlag3 = this.state.showFlag3;
        // const showFlag4 = this.state.showFlag4;
        // const showFlag5 = this.state.showFlag5;
        // const showFlag6 = this.state.showFlag6;
        // const showFlag7 = this.state.showFlag7;
        // const showFlag8 = this.state.showFlag8;
        // const showFlag9 = this.state.showFlag9;
        //   ↑　もとは上のコメント　それを分割代入した
        // 分割代入
        const {showFlag,showFlag2,showFlag3,showFlag4,showFlag5,showFlag6,showFlag7,showFlag8,showFlag9 } = this.state;
        
        // showFlag という変数がtrueの場合　AnswerField要素を格納
        //                      falseの場合　空白表示にする
        let text1 = showFlag ? <AnswerField id="1"/> : '';
        let text2 = showFlag2 ? <AnswerField id="2"/> : '';
        let text3 = showFlag3 ? <AnswerField id="3"/> : '';
        let text4 = showFlag4 ? <AnswerField id="4"/> : '';
        let text5 = showFlag5 ? <AnswerField id="5"/> : '';
        let text6 = showFlag6 ? <AnswerField id="6"/> : '';
        let text7 = showFlag7 ? <AnswerField id="7"/> : '';
        let text8 = showFlag8 ? <AnswerField id="8"/> : '';
        let text9 = showFlag9 ? <AnswerField id="9"/> : '';

        return (
            <MarginTop >
                {/* 9つの質問を掲載 */}
                <div className="text-center">
                    <QuestionTitle>YTクラス　よくあるご質問</QuestionTitle>
                </div>

                <MarginWid>
                    <div className="my-5">
                         <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag : !this.state.showFlag})}}>
                            Ｑ１…ＹＴクラスの入室条件はありますか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text1}
                    </div>
                        
                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag2 : !this.state.showFlag2})}}>
                            Ｑ２…ＹＴクラスの入室準備はいつから始めれば良いでしょうか？？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text2}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag3 : !this.state.showFlag3})}}>
                            Ｑ３…ＹＴクラスに中途入会することは可能でしょうか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text3}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag4 : !this.state.showFlag4})}}>
                            Ｑ４…やむを得ず授業を欠席した場合はどうなりますか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text4}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag5 : !this.state.showFlag5})}}>
                            Ｑ５…授業以外の補習や個別指導は有料ですか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text5}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag6 : !this.state.showFlag6})}}>
                            Ｑ６…土佐塾模試の受験は毎月必修ですか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text6}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag7 : !this.state.showFlag7})}}>
                            Ｑ７…料金表にないテストや合宿や特訓は参加すべきですか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text7}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag8 : !this.state.showFlag8})}}>
                            Ｑ８…諸事情(学校行事やどうしても辞められない習い事等)で、<br />土佐塾模試や毎週末の週例テスト受験が困難な場合、テストの参加方法がありますか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text8}
                    </div>

                    <div className="my-5">
                        <ButtonScope className="btn-scope-design" onClick={() => {this.setState({showFlag9 : !this.state.showFlag9})}}>
                            Ｑ９……一度入会してしまえば、無条件で卒業まで継続できますか？<IoIosArrowRoundDown />
                        </ButtonScope><br />
                        {text9}
                    </div>
                </MarginWid>
            </MarginTop>
        )
    }
}

export default Greeting;
